<template>
  <div class="content">
    <el-form ref="createForm" :model="createForm" :rules="createRules" @submit.native.prevent>
      <div class="form-item">
        <el-form-item label="选择类型" label-width="100px" hide-required-asterisk="true"></el-form-item>

        <div class="type_wrapper">
          <div class="content_type" :class="{'active': createForm.type == 'contest'}" @click="selectType('contest')">
            <div class="type_box">
              <i class="icon el-icon-edit"></i>
              <span class="title">比赛</span>
              <div class="line"></div>
              <p>是一种全场景教学方式，由综合教学、实训课堂、企业订单、竞赛课堂、测试课堂等组合而成，可自由拖拽，能够帮助老师构建混合式课堂。</p>
            </div>
          </div>
          <div class="content_type" :class="{'active': createForm.type == 'training'}" @click="selectType('training')">
            <div class="type_box">
              <i class="icon el-icon-video-camera-solid"></i>
              <span class="title">训练</span>
              <div class="line"></div>
              <p>是一种主要由视频组成的课堂形式，即可以进行翻转课堂也可以作为学生自学手段。</p>
            </div>
          </div>

        </div>
      </div>

      <el-form-item label="课程标题" prop="title" label-width="100px">
        <el-input v-model="createForm.title" name="title" placeholder="请输入标题" @keyup.enter.native="submitForm('createForm',handleCreate)"></el-input>
      </el-form-item>

      <div class="form-item submit_wrapper">
        <div class="input-block">
          <el-button type="primary" @click="submitForm('createForm',handleCreate)">开始创建</el-button>
          <el-button @click="closeDialog()">取消</el-button>
        </div>
      </div>
      <!-- <button ref="study" style="display:none" @click="edit(newId)"></button> -->
    </el-form>
  </div>
</template>

<script>
import { createCourse } from "@/api/course";
import { getToken } from "@/utils/auth";
import { url } from "@/utils/config";
import qs from 'qs';
export default {
  props: ["outerVisible"],
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    selectType(type) {
      this.createForm.type = type;
    },
    submitForm(formName, nextFunction) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          nextFunction();

        } else {
          return false;
        }
      });
    },
    handleCreate() {
      let that = this;

      let params = this.createForm;
      var data = [];

      createCourse(qs.stringify(params)).then(response => {
        this.$message.success({
          message: "添加成功",
          duration: 2000,
          onClose: function () {
            // that.$emit("fetchData");
            that.$emit("close");
            that.$emit('edit', { id: response.data.courseSet.id, type: response.data.courseSet.type })
            that.createForm.type = 'contest';
            that.createForm.title = "";
          }
        });

      });
    },
    closeCreate() {
      this.$refs["createForm"].resetFields();
    }
  },
  data() {
    return {
      createForm: {
        type: 'contest',
        title: ""
      },
      createRules: {
        title: [
          { required: true, trigger: "change", message: "请输入标题" },
          {
            min: 1,
            max: 30,
            message: "请输入1-30 个字符",
            trigger: "change"
          }
        ]
      },
      newWin: "",
      newId: "",
      activeIndex: 1
    };
  }
};
</script>

<style scoped>
.content {
  width: 1200px;
  margin: 20px auto 0;
}
.red {
  color: #ff5722;
}
.layui-form-label {
  width: 100px;
  font-size: 18px;
  vertical-align: middle;
}
.layui-form-label::before {
  content: " ";
  width: 5px;
  height: 20px;
  display: inline-block;
  margin-bottom: -3px;
  background-color: rgb(50, 179, 244);
}
/* .front_block{
    display: inline-block;
    width: 5px;
    height: 20px;
    background-color: rgb(50, 179, 244);
} */
.type_wrapper {
  width: 100%;
  display: block;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.content_type {
  width: 220px;
  height: 280px;
  margin-right: 20px;
  background-color: rgb(244, 246, 248);
  border-radius: 10px;
  color: #000000;
  cursor: pointer;
  /* float: left; */
}
.type_box {
  height: 100%;
  padding: 40px 20px 20px;
  text-align: center;

  font-size: 13px;
}

.icon {
  font-size: 40px;
  display: inline;
  /* margin: 40px 0 10px; */
}
.line {
  margin: 20px 0 10px;
  border-bottom: 1px solid #d2d2d2;
}
.title {
  display: block;
  font-size: 16px;
}
.active {
  background: rgb(50, 179, 244);
  color: #ffffff !important;
}
.input-block {
  margin-left: 30px;
  min-height: 36px;
}
.submit_wrapper {
  text-align: center;
}
.form-item {
  margin-bottom: 30px;
}
.xing {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  line-height: 26px;
  color: #f00;
}
</style>
